import {trackPromise} from "react-promise-tracker";
import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";

export const createUser = (payload) => {
  const url = getUrl("listUser");
  return trackPromise(Call.post(url, payload));
};

export const getUsers = (pageUrl) => {
  const url = pageUrl ? pageUrl : getUrl("listUser");
  return trackPromise(Call.get(url));
};

export const editUser = (data = {}) => {
  const {id = ""} = data;
  const url = getUrl("listUser");
  const patchUrl = `${url}${id}/`;
  return trackPromise(Call.patch(patchUrl, data));
};

export const deleteUser = (id = "") => {
  const url = getUrl("listUser");
  const patchUrl = `${url}${id}/`;
  return trackPromise(Call.delete(patchUrl));
};

export const getUserProfileAsync = () => {
  const url = getUrl("profile");
  return trackPromise(Call.get(url));
};

export const getCustomerUserProfileAsync = () => {
  const url = getUrl("CustomerUserProfile");
  return trackPromise(Call.get(url));
};

export const getOrgUsersAsync = (currentUser) => {
  const url = getUrl("orgUsers")(currentUser);
  return trackPromise(Call.get(url));
};

export const changeOwnerAsync = (data, orgId) => {
  const url = getUrl("changeOwner")(orgId);
  return trackPromise(Call.post(url, data));
};

export const getUserResourcesAsync = () => {
  const url = getUrl("profileResources");
  return trackPromise(Call.get(url));
};

export const saveUserSettingsAsync = (payload) => {
  const url = getUrl("userSettings");
  return trackPromise(Call.patch(url, payload));
};
